module.exports = __webpack_public_path__ + "img/vertical_6_1_3016.8cc7dce3.png";